import React from "react";

// The game board as crisp HTML: question banner, CSS-3D flip tiles, tug bar.
// `flash` = {color: 'wrong'|'dup', n} — bump n to flash the banner.
const HtmlBoard = ({
  kicker,
  question,
  answers = [],
  revealed = [],
  multiplierLabel,
  flash,
  leftPct = 0,
  rightPct = 0,
  showTug = true,
  footer = null,
}) => {
  const flashClass =
    flash && flash.n > 0
      ? flash.color === "dup"
        ? "flash-dup"
        : "flash-wrong"
      : "";

  return (
    <div className={`board-wrap ${flashClass}`}>
      {multiplierLabel && <div className="mult-badge">{multiplierLabel}</div>}
      <div className="q-banner" key={`flash-${flash?.n || 0}`}>
        <div className="q-kicker">{kicker || "GUESS THEIR ANSWERS"}</div>
        <div className="q-text">{question}</div>
      </div>

      {answers.length > 0 && (
        <div className="tile-grid">
          {answers.map((a, i) => (
            <div
              key={i}
              className={`tile ${revealed[i] ? "revealed" : ""} ${
                a.isKeyAns === "yes" ? "key" : ""
              }`}
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <div className="tile-inner">
                <div className="tile-face tile-front">
                  <div className="num">{i + 1}</div>
                </div>
                <div className="tile-face tile-back">
                  <span className="ans">{a.ans}</span>
                  <span className="pts">{a.point}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showTug && (
        <div className="tug">
          <div className="pct left">{Math.round(leftPct)}%</div>
          <div className="tug-track">
            <div className="tug-fill left" style={{ width: `${leftPct}%` }} />
          </div>
          <div className="tug-mid">⚡</div>
          <div className="tug-track">
            <div className="tug-fill right" style={{ width: `${rightPct}%` }} />
          </div>
          <div className="pct right">{Math.round(rightPct)}%</div>
        </div>
      )}

      {footer}
    </div>
  );
};

export default HtmlBoard;
